export default {
      id: "oc-mobile-usage",
      viewBox: "0 0 1077 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-mobile",
      toString: function () {
        return this.url;
      }
    }